import { getDocs, getDoc, doc, collection } from 'firebase/firestore'
import { fetchAndCacheImage } from '@helpers/imageHelper'
import { logger } from '@helpers/logger' // Updated to use the new log structure

export const getSportsLeaguesData = async (db, leaguesData, setLeaguesData) => {
  const params = {} // You can add relevant parameters here if needed
  const logComplete = logger.serviceRequest('getSportsLeaguesData', params) // Log service request
  const sports = ['soccer', 'rugby', 'basketball', 'american-football', 'cricket', 'ice-hockey'] // Add more sports as needed
  const newLeaguesData = { sports: {} }

  try {
    const fetchSportData = async (sport) => {
      // Use cached data if available
      if (leaguesData.sports[sport]) {
        newLeaguesData.sports[sport] = leaguesData.sports[sport]
        return
      }

      const querySnapshot = await getDocs(collection(db, 'sports', sport, 'leagues'))
      const documents = querySnapshot.docs.reduce((acc, docSnap) => {
        const data = docSnap.data()
        if (data.strCurrentSeason && data.strCurrentSeason !== '') {
          acc[docSnap.id] = { id: docSnap.id, ...data }
        }
        return acc
      }, {})
      newLeaguesData.sports[sport] = documents
    }

    // Fetch league data for all sports
    await Promise.all(sports.map((sport) => fetchSportData(sport)))

    // For each sport, for each league:
    // 1. Fetch the season document corresponding to league.strCurrentSeason to get isComplete
    // 2. Fetch and cache the league's images concurrently.
    await Promise.all(
      sports.map(async (sport) => {
        const leagues = newLeaguesData.sports[sport]
        await Promise.all(
          Object.values(leagues).map(async (league) => {
            // Fetch season data if strCurrentSeason exists
            if (league.strCurrentSeason) {
              const seasonRef = doc(db, 'sports', sport, 'leagues', league.id, 'seasons', league.strCurrentSeason)
              const seasonDoc = await getDoc(seasonRef)
              if (seasonDoc.exists()) {
                league.isComplete = seasonDoc.data().isComplete
                league.activeSeason = { id: league.strCurrentSeason, ...seasonDoc.data() }
              }
            }
            // Fetch images for league badge and logo concurrently
            await Promise.all([
              fetchAndCacheImage(league.strBadge).catch(() => {}),
              fetchAndCacheImage(league.strLogo).catch(() => {})
            ])
          }),
        )
      }),
    )

    setLeaguesData(newLeaguesData)
    logComplete() // Call the completion logging function
  } catch (error) {
    logger.error('getSportsLeaguesData', error)
    logComplete() // Call the completion logging function even on error
  }
}
